import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_URL || "https://aksubeb.cloud/api";

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aksubeb_admin_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      "Something went wrong";

    return Promise.reject({
      ...error,
      cleanMessage: message,
    });
  }
);

export default api;